// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `drop-down-options {
  display: flex;
  align-items: flex-end;
  flex-direction: column;
}
drop-down-options .trigger {
  cursor: pointer;
}
drop-down-options .edit-menu-container {
  position: relative;
}
drop-down-options .edit-menu-container .edit-menu {
  position: absolute;
  display: flex;
  flex-direction: column;
  z-index: 1;
  min-width: 100px;
  background-color: white;
  border-radius: var(--border-radius);
  box-shadow: 0px 0px 5px grey;
  transform: translateX(-100%);
  margin-top: var(--motes-padding);
}
drop-down-options .edit-menu-container .edit-menu > :first-child {
  border-radius: 10px 10px 0px 0px;
}
drop-down-options .edit-menu-container .edit-menu > :last-child {
  border-radius: 0px 0px 10px 10px;
}
drop-down-options .edit-menu-container .edit-menu > :only-child {
  border-radius: 10px;
}
drop-down-options .edit-menu-container .edit-menu > :not(:last-child) {
  border-bottom: 1px var(--motes-lighter-gray) solid;
}
drop-down-options .edit-menu-container .edit-menu button {
  cursor: pointer;
  background: none;
  border: none;
  text-align: left;
  padding: 12px 14px;
  margin: 0px;
  background-color: inherit;
  transition: 0.15s background-color;
  white-space: nowrap;
  font-family: var(--text-font);
}
drop-down-options .edit-menu-container .edit-menu button:not([disabled]):hover {
  background-color: var(--primary-color);
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/drop-down-options/drop-down-options.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,qBAAA;EACA,sBAAA;AACJ;AACI;EACI,eAAA;AACR;AAEI;EACI,kBAAA;AAAR;AAEQ;EACI,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,UAAA;EACA,gBAAA;EACA,uBAAA;EACA,mCAAA;EACA,4BAAA;EACA,4BAAA;EACA,gCAAA;AAAZ;AAEY;EACI,gCAAA;AAAhB;AAGY;EACI,gCAAA;AADhB;AAIY;EACI,mBAAA;AAFhB;AAKY;EACI,kDAAA;AAHhB;AAMY;EACI,eAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,kCAAA;EACA,mBAAA;EACA,6BAAA;AAJhB;AAOY;EACI,sCAAA;AALhB","sourcesContent":["drop-down-options {\n    display: flex;\n    align-items: flex-end;\n    flex-direction: column;\n\n    .trigger {\n        cursor: pointer;\n    }\n\n    .edit-menu-container {\n        position: relative;\n\n        .edit-menu {\n            position: absolute;\n            display: flex;\n            flex-direction: column;\n            z-index: 1;\n            min-width: 100px;\n            background-color: white;\n            border-radius: var(--border-radius);\n            box-shadow: 0px 0px 5px grey;\n            transform: translateX(-100%);\n            margin-top: var(--motes-padding);\n\n            > :first-child {\n                border-radius: 10px 10px 0px 0px;\n            }\n\n            > :last-child {\n                border-radius: 0px 0px 10px 10px;\n            }\n\n            > :only-child {\n                border-radius: 10px;\n            }\n\n            > :not(:last-child) {\n                border-bottom: 1px var(--motes-lighter-gray) solid;\n            }\n\n            button {\n                cursor: pointer;\n                background: none;\n                border: none;\n                text-align: left;\n                padding: 12px 14px;\n                margin: 0px;\n                background-color: inherit;\n                transition: 0.15s background-color;\n                white-space: nowrap;\n                font-family: var(--text-font);\n            }\n\n            button:not([disabled]):hover {\n                background-color: var(--primary-color);\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
